/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useRef, useState } from 'react';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import NotificationPopUp from '../../../containers/TrainingWebinar/components/NotificationPopUp';
import { LanguageContext } from '../../../libs/Context';
import Loading from '../../../components/Common/Loaders/FullWidthLoader/Loading';
import useJoinReqSeat from '../../../containers/TrainingWebinar/customHooks/BookNdJoinSeat';

const TrainingNotification = (props) =>
{
	const { data, session } = props;
	const meeting = data?.data;
	const navigate = useNavigate();
	const [ isBooked, setIsBooked ] = useState({ open: false, type: '' });
	const { language } = useContext(LanguageContext);
	const [ loading, setLoading ] = useState<boolean>(false);
	const isMeetingEnded = meeting?.startTime + meeting?.duration <= new Date().valueOf();
	const disablBs:any = meeting?.bookedUsers?.includes(session?.userId) || isMeetingEnded;
	const bookSeat = useRef<boolean>(disablBs);
	const isRsvp = meeting?.rsvp;
	const isMeetingBooked = meeting?.bookedUsers?.includes(session?.userId);
	const isSeatsAvailable = (meeting?.rsvp && !meeting?.limit) || (meeting?.rsvp && meeting?.limit && meeting?.noOfSeats > (meeting?.bookedUsers?.length ?? meeting?.seatBooked));
	const isPanelistOrCohost = [ ...meeting?.panalistIds ?? [], ...meeting?.coHostIds ?? [] ].includes(session?.userId);
	const isCohost = [ ...meeting?.coHostIds ?? [] ].includes(session?.userId);
	const isHost = meeting?.creatorId === session.userId;
	const isUserStartTimeValid = new Date().valueOf() > meeting?.startTime - (isCohost || isHost ? 30 : 5) * 60000;

	const onJoin = () =>
	{
		if (new Date().valueOf() < (meeting?.startTime + meeting?.duration))
		{
			navigate(`/join-confernece/${window.btoa(meeting?.meetingId)}?email=${window.btoa(session?.email)}`);
		}
		else
		{
			toast.error(language?.SryLinkExpire, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
	};

	const getJoinReqStatus = useJoinReqSeat();
	const handleTrainingSeat = async () =>
	{
		const res = await getJoinReqStatus(meeting, isSeatsAvailable, loading, setLoading,
			() => {}, bookSeat, () => {});

		if (res) setIsBooked({ open: true, type: res });
	};

	const checkCond = [ 'training_invitation', 'training_alert', 'training_updated' ].includes(meeting?.type) && isRsvp && !isPanelistOrCohost && !isMeetingBooked;

	return (
		<>
			{loading && <Loading />}
			<div className='flexCol pdngLMD	'>
				<span className='wordBreakWord'>{meeting?.message}</span>
			</div>
			<div className='flexCol pdngLMD mrgnTMD'>
				<span className='subHeadingSM'>Event Detail</span>
				<div className='flexCol pdngBSM'>
					<span className='titleHeading subHeadingXS pdngVSM wordBreakWord'>{meeting?.title}</span>
					<span className='pdngBSM lightTxt wordBreakWord'>{meeting?.description}</span>
					<span className='pdngBSM lightTxt'>{new Date(meeting?.startTime).toLocaleString('en-US')}, {meeting?.duration / 60000} min</span>

					{data.sentBy !== session.userId &&
					<>
						{checkCond &&
						<span className='pdngBSM'>
							{isSeatsAvailable ? 'Click button, to book your seat now' : 'Seats are full please request session host to join the session'}
						</span>}

						{([ 'training_slot_confirmation', 'invitation' ].includes(meeting?.type) ||
						([ 'training_invitation', 'training_alert', 'training_updated' ].includes(meeting?.type) && (!isRsvp || isPanelistOrCohost)) || isMeetingBooked) &&
						<span className='pdngBSM'>To join this {meeting?.meetingType}, please click below button</span>}

						{meeting?.type === 'training_cancelled' &&
							<span className='pdngBSM'>This {meeting?.meetingType} has been cancelled!</span>}
					</>}

				</div>
				<div className='flexInline pdngVSM'>
					{checkCond &&
					<Button variant='contained' disableElevation disableRipple className='whiteTxt' disabled={isMeetingEnded || !isUserStartTimeValid} onClick={handleTrainingSeat}>
						{isSeatsAvailable ? language?.bookSeat : 'Request'}
					</Button>}

					{([ 'training_slot_confirmation', 'invitation' ].includes(meeting?.type) ||
						([ 'training_invitation', 'training_alert', 'training_updated' ].includes(meeting?.type) && (!isRsvp || isPanelistOrCohost)) || isMeetingBooked) &&
						<span className='pointer'>
							<Button onClick={onJoin} disabled={isMeetingEnded || !isUserStartTimeValid} className='whiteTxt' variant='contained' size='small' disableElevation disableRipple>
								{isHost ? language?.start : language?.join}
							</Button>
						</span>}
				</div>
			</div>
			<NotificationPopUp open={isBooked?.open} close={() => setIsBooked({ open: false, type: '' })} type={isBooked?.type} training={meeting}/>
		</>
	);
};

export default TrainingNotification;